/**
 * Generates the account code based on whether the user belongs to an organization
 * @param userId - The user's ID
 * @param organizationId - The organization ID from subscription (null if not part of an org)
 * @returns Formatted account code string (org_XXX or user_XXX)
 */
export const getAccountCode = (userId: number | undefined, organizationId: number | null | undefined): string => {
    if (organizationId) {
        return `org_${organizationId}`;
    }
    return `user_${userId}`;
};
